const localizeName = (name:{en: string, fr: string}) => {
    if (navigator.language.includes('fr')) {
        return name.fr.length ? name.fr : name.en;
    }

    return name.en.length ? name.en : name.en;
};

export default localizeName;
